import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'app/baseQuery';
import { getConfig } from 'config/config-helper';

const { dataopsAdminAppApiEndpoint } = getConfig();

export const adminApi = createApi({
  reducerPath: 'adminApi',
  baseQuery: retry(
    axiosBaseQuery({
      baseUrl: dataopsAdminAppApiEndpoint,
    }),
    {
      retryCondition: (e: any, __, { attempt }) => {
        if (e.originalStatus !== undefined && e.originalStatus >= 500 && e.originalStatus < 600 && attempt <= 3) {
          return true;
        }
        return false;
      },
    },
  ),
  keepUnusedDataFor: 600,
  tagTypes: [],
  endpoints: (builder) => ({
    forceSync: builder.mutation<undefined, { projectId: number }>({
      query: (params) => ({
        url: `/github-integration/installations/mirror/sync/${params.projectId}`,
        method: 'POST',
        params: {},
      }),
    }),
  }),
});

export const { useForceSyncMutation } = adminApi;
